<div class="container" style="margin-top: 32px;">
  <h2>What you will learn?</h2>
  <div class="card">
    <div class="card-body">
      <p [innerHTML]="content"></p>
    </div>
  </div>
</div>
